module.exports = __webpack_public_path__ + "static/media/info.e78e969d.svg";